export const SUPPORT_DIAGNOSTIC_SCHEMA = 'app-guincho-support-diagnostic/v1' as const;

export type SupportDiagnosticLevel = 'debug' | 'info' | 'warn' | 'error';

export type SupportDiagnosticValue =
  | null
  | boolean
  | number
  | string
  | SupportDiagnosticValue[]
  | { [key: string]: SupportDiagnosticValue };

export interface SupportDiagnosticEventInput {
  occurredAt?: string;
  level: SupportDiagnosticLevel;
  category: string;
  name: string;
  message?: string;
  data?: unknown;
}

export interface SupportDiagnosticEvent {
  id: number;
  occurredAt: string;
  lastOccurredAt: string;
  level: SupportDiagnosticLevel;
  category: string;
  name: string;
  message: string;
  data: SupportDiagnosticValue;
  repetitions: number;
}

export interface SupportDiagnosticBufferStats {
  eventCount: number;
  byteLength: number;
  droppedByEventLimit: number;
  droppedByByteLimit: number;
  compactedEventCount: number;
}

export interface SupportDiagnosticSnapshot {
  schema: typeof SUPPORT_DIAGNOSTIC_SCHEMA;
  diagnosticId: string;
  createdAt: string;
  metadata: SupportDiagnosticValue;
  events: readonly SupportDiagnosticEvent[];
  stats: Readonly<SupportDiagnosticBufferStats>;
}

export interface SupportDiagnosticConsent {
  granted: true;
  grantedAt: string;
  purpose: 'support_diagnostic';
}

export interface PreparedSupportDiagnostic {
  diagnosticId: string;
  administrativeRequestId?: string;
  createdAt: string;
  byteLength: number;
  sha512: string;
  contentType: 'application/vnd.app-guincho.support-diagnostic+json';
  idempotencyKey: string;
  body: Uint8Array;
  snapshot: SupportDiagnosticSnapshot;
}

export interface SupportDiagnosticUploadRequest {
  diagnosticId: string;
  byteLength: number;
  sha512: string;
  contentType: 'application/vnd.app-guincho.support-diagnostic+json';
  idempotencyKey: string;
  body: Uint8Array;
}

export interface SupportDiagnosticUploadReceipt {
  diagnosticId: string;
  protocol: string;
  remotePath: string;
  sha512: string;
  byteLength: number;
}

export interface SupportDiagnosticTransport {
  uploadExplicit(request: SupportDiagnosticUploadRequest): Promise<SupportDiagnosticUploadReceipt>;
}

export interface SupportDiagnosticPreparedStore {
  save(prepared: PreparedSupportDiagnostic): Promise<void>;
  load(diagnosticId: string): Promise<PreparedSupportDiagnostic | null>;
  loadLatest(): Promise<PreparedSupportDiagnostic | null>;
  remove(diagnosticId: string): Promise<void>;
}
